import React, { FC } from 'react'
import { ErrorMessage } from 'components/Error'
import { Spacer } from 'components/Utility'

type Props = {
  name: string
  contact: string
  responsiblePerson: string
}

const ShopAccountError: FC<Props> = React.memo((props) => {
  const { name, contact, responsiblePerson } = props
  return (
    <div>
      {name === '' && (
        <>
          <ErrorMessage caution={`特定商取引法に関する記載を入力してください。`} id={'name'} />
          <Spacer size={12} />
        </>
      )}
      {contact === '' && (
        <>
          <ErrorMessage caution={`販売業者の住所および連絡先を入力してください。`} id={'contact'} />
          <Spacer size={12} />
        </>
      )}
      {responsiblePerson === '' && (
        <>
          <ErrorMessage caution={`販売業者の代表者または販売責任者を入力してください。`} id={'responsible-person'} />
          <Spacer size={12} />
        </>
      )}
    </div>
  )
})

export default ShopAccountError
